import styled from 'styled-components';

import {
    spaceMixin,
} from '@zillow/constellation';

export const StyledStatusComponent = styled.div`
    margin-bottom: ${spaceMixin('sm')};
`;
